var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetodologyFleshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9791 0.893311C10.725 0.904979 -0.0116587 11.6592 9.50138e-06 24.9142C0.0116777 38.1693 10.7659 48.905 24.0209 48.8933C37.2682 48.8816 48 38.1401 48 24.8928C47.9776 11.6397 37.2332 0.904979 23.9791 0.893311ZM33.8329 22.5076L33.8125 22.5281L24.4779 39.4129C24.3068 39.7347 23.9713 39.9351 23.6067 39.9312H23.316C22.8784 39.7911 22.5886 39.374 22.611 38.9151L23.0884 28.8542H14.9985C14.6523 28.8503 14.3315 28.6704 14.1477 28.3767C13.9659 28.0695 13.9659 27.6883 14.1477 27.3811L23.4822 10.3718C23.7068 9.9556 24.1882 9.74946 24.6442 9.87392C25.0779 10.0198 25.3647 10.433 25.3491 10.89L24.8931 20.9509H32.983C33.3418 20.9509 33.6695 21.1503 33.8339 21.4692C34.0497 21.7813 34.0497 22.1946 33.8339 22.5067L33.8329 22.5076Z",
    fill: "#64B5F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetodologyFleshIcon);
export default __webpack_public_path__ + "static/media/metodology-flesh-icon.85ffd8745d759bd3a2adb1ada3b4e157.svg";
export { ForwardRef as ReactComponent };